import { render, staticRenderFns } from "./SelectModuleModal.vue?vue&type=template&id=8dd30ef4&"
import script from "./SelectModuleModal.vue?vue&type=script&lang=js&"
export * from "./SelectModuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports